"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.YearSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _StyledComponent = require("../StyledComponent.js");
var _images = require("../../../DatePickerInput/assets/images.js");
var _utils = require("../../utils.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const YearSelector = props => {
  const {
    textColor,
    selectedColor,
    selectedBg,
    disabledDaysColor,
    currentYearMonth,
    setShowDateSelector,
    setCurrentYearMonth,
    maxDate,
    minDate,
    startYear,
    borderRadius,
    yearFontFamily,
    yearFontStyle,
    yearFontWeight,
    yearFontSize,
    yearTransformation,
    yearDecoration,
    yearTextColor,
    hoverYearTextColor,
    hoverYearBgColor,
    currentYearBgColor,
    currentYearBorderRadius,
    currentYearBorderWidth,
    currentYearBorderStyle,
    currentYearBorderColor,
    currentYearBoxShadow,
    currentYearFontFamily,
    currentYearFontStyle,
    currentYearFontWeight,
    currentYearFontSize,
    currentYearTransformation,
    currentYearDecoration,
    currentYearTextColor,
    selectedYearBgColor,
    selectedYearBorderRadius,
    selectedYearBorderWidth,
    selectedYearBorderStyle,
    selectedYearBorderColor,
    selectedYearBoxShadow,
    selectedYearFontFamily,
    selectedYearFontStyle,
    selectedYearFontWeight,
    selectedYearFontSize,
    selectedYearTransformation,
    selectedYearDecoration,
    selectedYearTextColor
  } = props;
  const selectedRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (selectedRef?.current) {
      selectedRef.current?.scrollIntoView?.({
        behavior: 'smooth',
        inline: 'nearest',
        block: 'center'
      });
    }
  }, [selectedRef?.current]);
  const minYear = startYear ?? _utils.defaultStartYear;
  const maxYear = new Date().getFullYear() + 100;
  const handleYearClick = year => {
    setCurrentYearMonth(prevState => {
      const newState = new Date(prevState).setFullYear(year);
      return new Date(newState);
    });
    handleBackClick();
  };
  const todayValue = new Date();
  const currentYear = todayValue.getFullYear();
  const getDateList = () => {
    let component = [];
    let col = [];
    const currentSelectedYear = new Date(currentYearMonth).getFullYear();
    const disabledFromYear = maxDate ? new Date(maxDate).getFullYear() : maxYear;
    const disableBeforeMinYear = minDate ? new Date(minDate).getFullYear() : minYear;
    for (let index = minYear; index <= maxYear; index++) {
      const selected = currentSelectedYear === index;
      const disabled = index > disabledFromYear || index < disableBeforeMinYear;
      col.push(/*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledCol, {
        className: `mun-date-picker-year__value ${selected ? 'mun-date-picker-year__value-selected' : ''}`,
        textColor: yearTextColor || textColor,
        selectedColor: selectedYearTextColor || selectedColor,
        selectedBg: selectedYearBgColor || selectedBg,
        isSelected: selected,
        disabled: disabled,
        disabledDaysColor: disabledDaysColor,
        ref: selected ? selectedRef : undefined,
        onClick: () => !disabled && handleYearClick(index),
        borderRadius: borderRadius,
        fontFamily: yearFontFamily,
        fontStyle: yearFontStyle,
        fontWeight: yearFontWeight,
        fontSize: yearFontSize,
        transformation: yearTransformation,
        decoration: yearDecoration,
        onHoverTextColor: hoverYearTextColor,
        onHoverBgColor: hoverYearBgColor,
        isCurrent: currentYear === index,
        currentBgColor: currentYearBgColor,
        currentBorderRadius: currentYearBorderRadius,
        currentBorderWidth: currentYearBorderWidth,
        currentBorderStyle: currentYearBorderStyle,
        currentBorderColor: currentYearBorderColor,
        currentBoxShadow: currentYearBoxShadow,
        currentFontFamily: currentYearFontFamily,
        currentFontStyle: currentYearFontStyle,
        currentFontWeight: currentYearFontWeight,
        currentFontSize: currentYearFontSize,
        currentTransformation: currentYearTransformation,
        currentDecoration: currentYearDecoration,
        currentTextColor: currentYearTextColor,
        selectedBorderRadius: selectedYearBorderRadius,
        selectedBorderWidth: selectedYearBorderWidth,
        selectedBorderStyle: selectedYearBorderStyle,
        selectedBorderColor: selectedYearBorderColor,
        selectedBoxShadow: selectedYearBoxShadow,
        selectedFontFamily: selectedYearFontFamily,
        selectedFontStyle: selectedYearFontStyle,
        selectedFontWeight: selectedYearFontWeight,
        selectedFontSize: selectedYearFontSize,
        selectedTransformation: selectedYearTransformation,
        selectedDecoration: selectedYearDecoration,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledTypography, {
          children: index
        })
      }));
      if (col.length === 3) {
        component.push(/*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledRow, {
          className: "mun-date-picker-year__row",
          children: col
        }));
        col = [];
      }
    }
    if (col.length > 0) {
      component.push(/*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledRow, {
        className: "mun-date-picker-year__row",
        children: col
      }));
    }
    return component;
  };
  const handleBackClick = () => {
    setShowDateSelector();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StyledComponent.StyledYearSelector, {
    className: "mun-date-picker-year",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledSvgIconContainer, {
      onClick: handleBackClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledSvgIcon, {
        className: 'mun-date-picker-month__icon',
        url: _images.DatePickerLeftIcon,
        fillColor: textColor,
        fillHoverColor: selectedColor
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledYearSelectorContainer, {
      children: getDateList()
    })]
  });
};
exports.YearSelector = YearSelector;
var _default = exports.default = YearSelector;